// Modules
import React, { Component } from 'react';
// @ts-ignore
import { LocalizationContext } from 'react-localize';
import moment from "moment";

// Styles
import './DatePicker.scss';

// Interfaces
import {Tip} from 'Interfaces/TipInterface';

// Components
import Calendar from '../Calendar';
import MvCalendarLegend from '../MvCalendarLegend';
import MvSelect from 'Generic/MvSelect';
import MvLoader from 'Generic/MvLoader/MvLoader'

interface IProps {
    data: any[];
    startDate: any;
    enabledDates: (string | Date)[];
    numberOfMonths:number;
    onDayClick(date:Date):void;
    searchMonths: any;
    refreshAvailability(date:any): void;
    activeDate: Date | null;
    dayTooltips?: {[index: string]: Tip[]};
    loader:boolean
    isDateOutsideWindow(date: Date): boolean;
    hasLoadError: boolean;
}

interface IState {
    selectedMonth:any;
    showModal: boolean;
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
class DatePicker extends Component<IProps, IState> {

    public static defaultProps= {
        selectedMonths: [],
        availableDates: [],
        numberOfMonths: 1
    }

    constructor(props: IProps) {
        super(props);
        this.nextMonth = this.nextMonth.bind(this);
        this.previousMonth = this.previousMonth.bind(this);
        this.setCalendarPosition = this.setCalendarPosition.bind(this);
        this.handleInput = this.handleInput.bind(this);

        this.state = {
            selectedMonth: null,
            showModal: false
          };
    }

    nextMonth() {
        if(this.checkDisableNext()) {
            const selectedMonth = this.getDateForPosition();
            const nextMonth = selectedMonth.setMonth(selectedMonth.getMonth() + 1);
            this.props.refreshAvailability(nextMonth);
        }
    }

    previousMonth() {
        if(this.checkDisablePrev()) {
            const selectedMonth = this.getDateForPosition();
            const prevMonth = selectedMonth.setMonth(selectedMonth.getMonth() - 1);
            this.props.refreshAvailability(prevMonth);
        }
     }

    setCalendarPosition( selectedMonth: Date){
        this.props.refreshAvailability(selectedMonth)
        this.setState({ selectedMonth: selectedMonth });
    }

    getDateForPosition():Date {
        return new Date(this.props.startDate)
    }

    handleInput(e:any){
        const target = e.target;
        let value = target.value;
        this.setCalendarPosition(new Date(value))
    }

    checkDisablePrev():boolean {
        const selectedMonth = new Date(moment(this.getDateForPosition()).startOf('month').toString());
        const firstAvailableDate = new Date(this.props.searchMonths[0].value);
        const firstAvailableMonth = new Date(moment(firstAvailableDate).startOf('month').toString());

        if(selectedMonth.getTime() === firstAvailableMonth.getTime()){
          return false
        }
        return true
    }

    checkDisableNext(): boolean {
        const selectedMonth = new Date(moment(this.getDateForPosition()).startOf('month').toString());
        const lastAvailableDate = new Date(this.props.searchMonths[this.props.searchMonths.length-1].value);
        const lastAvailableMonth = new Date(moment(lastAvailableDate).startOf('month').toString());
        
        if(selectedMonth.getTime() === lastAvailableMonth.getTime()){
          return false
        }
        return true
    }

    render() {
        let year = this.getDateForPosition().getFullYear()
        let month = this.getDateForPosition().getMonth()
    

        return (
            <div className="date-picker">
                <MvLoader show={this.props.loader}>
                <div className="calendar-wrapper">
                    <div className="date-picker-nav">
                        <button className="date-picker-prev date-picker-nav-button" onClick={this.previousMonth}>previous month</button>
                        <div className="mv-select-container">
                            <MvSelect
                                name="startDate"
                                onChange={this.handleInput}
                                label={`${monthNames[month]} ${year}`}
                                value= {`${monthNames[month]} ${year}`}
                                items={this.props.searchMonths}
                                tabIndex={0}
                            />
                        </div>
                        <button className="date-picker-next date-picker-nav-button" onClick={this.nextMonth}>next month</button>
                    </div>
                    <div  className="calendar-container">
                        <Calendar
                            year={year}
                            month={month}
                            enabledDates={this.props.enabledDates}
                            onDayClick={this.props.onDayClick}
                            activeDate={this.props.activeDate}
                            dayTooltips={this.props.dayTooltips}
                            isDateOutsideWindow={this.props.isDateOutsideWindow}
                            hasLoadError={this.props.hasLoadError}
                        />
                    </div>
                </div>
                </MvLoader>
                <MvCalendarLegend openModal={this.state.showModal} showModal={()=> this.setState({showModal: !this.state.showModal})}/>
            </div>
        );
    }
}
DatePicker.contextType = LocalizationContext;
export default DatePicker;
